import { useTheme } from "@mui/material/styles";
import Alert from "@mui/material/Alert";
import Typography from "@mui/material/Typography";

import Box from "@subly/s1/ui/atom/Box";
import Form from "@subly/s1/ui/atom/Form";
import Content from "@subly/s1/ui/composed/Content";

import { useWelcomeBranding } from "../fabric";
import Actions from "./Actions";


export default function Branding() {
	const { form, getArticle, upload } = useWelcomeBranding();
	const theme = useTheme();
	console.log(theme);

	const style = {
		content: { width: "100%", justifyContent: "space-between", flexWrap: "wrap" },
		left: { flex: "1 1 400px", minWidth: 0 },
		right: { flex: "1 1 270px", alignItems: "center" },
		article: {
			boxShadow: theme.shadows["10"]
		}
	} satisfies SxProps;

	return (
		<Form>
			<form.AppForm>
				<Box gap={2} sx={style.content}>
					<Box.Column gap={1.25} sx={style.left}>
						<form.AppField name="url" children={(field) => <field.Input label="Publication URL" type="url" placeholder="Enter the URL of your publication" required />} />
						<form.AppField name="logo.dark" children={(field) => <field.Image label="Logo - Dark" maxSize={upload.size} required />} />
						<form.AppField name="logo.light" children={(field) => <field.Image label="Logo - Light" dark maxSize={upload.size} required />} />
						<form.AppField name="logo.mark" children={(field) => <field.Image label="Logo mark" maxSize={upload.size} required />} />
					</Box.Column>
					<Box.Column gap={2} sx={style.right}>
						<form.Subscribe selector={(state) => state.values.logo.dark}>
							{(logo) => {
								const article = getArticle(logo);
								return (
									<Box.Column>
										<Typography variant="h5">Preview:</Typography>
										<Content article={article} preview sx={style.article} />
									</Box.Column>
								);
							}}
						</form.Subscribe>
						<Alert variant="filled" severity="warning">
							For best results, upload your logo as an SVG. It stays sharp at any size and loads faster.
						</Alert>
					</Box.Column>
				</Box>
				<form.Subscribe selector={(state) => [state.canSubmit, state.isSubmitting]}>
					{([canSubmit, isSubmitting]) => <Actions canSubmit={canSubmit} isSubmitting={isSubmitting} onClick={form.handleSubmit} />}
				</form.Subscribe>
			</form.AppForm>
		</Form>
	);
};